const Data = [
 {
   "id": 51,
   "peopleid": 51,
   "title": "King of the Mountain",
   "address": "Cooroy Mountain, QLD",
   "desc": "You’d be hard pressed to find a pool that overlooks a more magical vista and enjoys a more stunning sunset than ‘Stonelea’. A hidden escape on the upper limit of the ridge line on lush Cooroy Mountain, the home itself is unapologetically decadent with the pool the centrepiece of this luxurious acreage estate. The living spaces open directly onto a terrace beside a 12m-long heated pool, which runs along the length of the house, offering panoramic views of the hinterland reaching all the way to the sea. It features a wet edge, like a waterfall cascading to the forest below, and on the lower level of the house, two portholes from the pool filter light into the subterranean media room, complete with 2000-bottle wine cellar. It features a wet edge, like a waterfall cascading to the forest below, and on the lower level of the house, two portholes from the pool filter light into the subterranean media room, complete with a 2000-bottle wine cellar.",
   "imagename1": "51-1",
   "imagename2": "51-2",
   "imagename3": "51-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 52,
   "peopleid": 52,
   "title": "Disco Pool",
   "address": "Esplanade, Manly, QLD",
   "desc": "This disco-style pool was built for partying and will make you the envy of friends and family. Designed by Australian award-winner Neville Cox and built by Innovate pools, it comes with a hot spa and sheer descent waterfall that cascades over a cave created by an overhanging deck. Turn on the LED lights, which you can change to suit your mood, and crank up the music for some aquatic fun before retiring to one of the tiered decking areas or the gazebo for cocktails. The property is for sale for $2.75m.",
   "imagename1": "52-1",
   "imagename2": "52-2",
   "imagename3": "52-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 53,
   "peopleid": 53,
   "title": "Midsummer's Eve",
   "address": "Waratah Rd, Palm Beach, NSW",
   "desc": "This incredible Palm Beach pool has been seamlessly integrated into the functioning of its home. Just metres from Pittwater and Palm Beach itself, the pool ensures the home is like a mini-resort. And if it gets to dinner and you have forgotten to have your daily swim, you're sure to get a gentle reminder.",
   "imagename1": "53-1",
   "imagename2": "53-2",
   "imagename3": "53-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 54,
   "peopleid": 54,
   "title": "View Envy",
   "address": "Vaucluse Road, Vaucluse, NSW",
   "desc": "Returning Chicago-based derivatives trader Andrew Killion will soon be lapping up the glorious pool at the Vaucluse trophy home he bought from media scion Alexander Ma in September for $30m. Designed by the renowned architect Bruce Stafford, the seven-bedroom home has eight bathrooms and a 12-car garage. It's been designed to maximise its world-class Sydney Harbour views. There's also a state-of-the-art cinema, commercial grade lift,gym and jacuzzi.",
   "imagename1": "54-1",
   "imagename2": "54-2",
   "imagename3": "54-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 55,
   "peopleid": 55,
   "title": "Tower's Eye View",
   "address": "ANZ Tower, Sydney CBD, NSW",
   "desc": "While the boast of this property being 'the best penthouse in the world' might just fall short, it was worth making for the pool's sake. It's a body of water that can match anything on offer in the great cities of the world: New York, Paris, Barcelona, Tokyo. Wading in that pool in your Billabong boardies or your Christian Dior budgy smugglers, it must really feel like you can reach out and touch Sydney Tower.",
   "imagename1": "55-1",
   "imagename2": "55-2",
   "imagename3": "55-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 56,
   "peopleid": 56,
   "title": "Balinese Kingdom",
   "address": "Mawson Lakes, SA",
   "desc": "After a summer afternoon or evening in this backyard pool, it would be easy to forget you’re not on an overseas tropical holiday. The modern Mawson Lakes home has a Balinese-inspired backyard, complete with a pool that has its very own sunken swim-upbar. Pull up a pew, which is built into the pool, and sip on a cold bevy without even leaving the water – then when you’re done,dry off under the Bali hut. The house also has an outdoor kitchen and covered entertainment area so there is plenty of space to host large groups of guests for summer splash bashes.",
   "imagename1": "56-1",
   "imagename2": "56-2",
   "imagename3": "56-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 57,
   "peopleid": 57,
   "title": "My Own Private Waterfall",
   "address": "Ballarat North, VIC",
   "desc": "This brilliant Ballarat pool should be the exception to the rule “don’t go chasing waterfalls”. Water cascades over the infinity-edged wall of the striking saltwater swimming spot to create the image of a waterfall at the contemporary home that sold for $1.61m in 2019. A tranquil leafy outlook is on offer from the pool, which adjoins a deck for sunbathing and entertaining, featuring an open fireplace. Views of Lake Wendouree can also be glimpsed from the 2200sq m property, which was designed by Madin Lyons Associates.",
   "imagename1": "57-1",
   "imagename2": "57-2",
   "imagename3": "57-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 58,
   "peopleid": 58,
   "title": "Infinite Views",
   "address": "Eltham, VIC",
   "desc": "What better way to relax than by having a paddle in a three-sided infinity pool with glorious views across the treetops? This is a reality for the lucky family who snapped up this Coldstream Stone-clad abode for an Eltham-record price of $3.7m in 2019. The vendor — a director of local building company Billings Long — spent about six years getting planning approval to create the three-storey house and its resort-style additions, Morrison Kleeman director Rocco Montanaro said at the time. These also included a spa, a floodlit tennis court and an alfresco area “resembling a Bali-style villa”.",
   "imagename1": "58-1",
   "imagename2": "58-2",
   "imagename3": "58-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 59,
   "peopleid": 59,
   "title": "Humble Brag",
   "address": "Karoola Crescent, Lindisfarne, TAS",
   "desc": "In Hobart, when property lovers talk about \"BMW\", they are not discussing expensive cars. Instead it is all about the bridge, mountain and water view that riverside homes like this one bask in. Here in Lindisfarne, you can take in the BMW from your elevated, opulent pool. By day it's a gorgeous vista, but by night it really comes alive - a twinkling fairyland of city lights bouncing on the river. And it is solar heated. Solar for sustainability, and heated for Hobart's 'fickle' summer swimming weather!",
   "imagename1": "59-1",
   "imagename2": "59-2",
   "imagename3": "59-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 60,
   "peopleid": 60,
   "title": "Warne's World",
   "address": "Brighton, VIC",
   "desc": "Howzat?! Spin king Shane Warne proudly emblazoned his cricket jersey number 23 into the tiles of the incredible pool found at the rear of his former 124-year-old Italianate residence. He once lived at the swish abode with his ex-fiance, actor Elizabeth Hurley. Warne added the personal inscription to the resort-style swim spot, which also featured more than six lounges and a water slide. The cricket legend sold the six-bedroom William Street mansion for $10.85m in 2013. A self-cleaning pool, flanked by a spa and alfresco and sunbathing decks, was a highlight of another Brighton beauty Warne recently sold in Newbay Crescent, which had a $5.8-$6.38m price guide.",
   "imagename1": "60-1",
   "imagename2": "60-2",
   "imagename3": "60-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 61,
   "peopleid": 61,
   "title": "Hide and Seek",
   "address": "Ascot Vale, VIC",
   "desc": "Not swimming weather? Then this solar-heated pool can be tucked away under turf, courtesy of a clever motorised platform. “It’s great in winter,” selling agent Liz Brettell said before the property’s $2.3m sale in 2018. “You’ve got the option of a bigger backyard.” The California bungalow has since sold again, for $2.55m last year. A sunbathing deck and covered alfresco deck flank the hi-tech hideaway pool to create a dreamy entertainer’s backyard.",
   "imagename1": "61-1",
   "imagename2": "61-2",
   "imagename3": "61-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 62,
   "peopleid": 62,
   "title": "Tallebudgera Smugglers",
   "address": "Tallebudgera Connection Road, Tallebudgera, QLD",
   "desc": "Sports enthusiasts will love the outlook from this large pool on this Palm Springs-inspired acreage estate in the Gold Coast hinterland. Featuring two floating loungers, fans can pull up a seat in the magnesium pool and take in a local game of footy or cricket as they escape the summer heat. Surrounded by palm trees and manicured lawns, the pool is at the centre of the L-shaped property which has floor-to-ceiling glass doors that when open, merge indoor and outdoor living. The property recently sold for $2.8m.",
   "imagename1": "62-1",
   "imagename2": "62-2",
   "imagename3": "62-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 63,
   "peopleid": 63,
   "title": "Grasstrees House",
   "address": "Adelaide Hills, SA",
   "desc": "There’s more to this impressive wet edge pool than meets the eye. As it runs parallel to the home, which is affectionately known as Grasstrees House, it reflects picturesque sunsets, gum trees, yaccas and other breathtaking vistas that surround it. Whether you’re cooling off in it on a warm summer day or admiring it as a form of ever-changing artwork that comes with the home, there is no denying this pool has a lot to offer. And what better spot to marvel at the panoramic views that surround the home with a glass of vino?",
   "imagename1": "63-1",
   "imagename2": "63-2",
   "imagename3": "63-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 64,
   "peopleid": 64,
   "title": "Swim-Up Bar",
   "address": "Lysterfield, VIC",
   "desc": "How’s this for a watering hole? This home’s incredible pool bar could compete with some of Australia’s best tropical resorts. Swimmers can wade through a water curtain that runs off the roof of the outdoor bar zone to submerged stools for a drink, all the while overlooking a full outdoor kitchen with a pizza oven and a barbecue. At the other end of the huge pool is an extravagant wet-edge glass spa. The pool package sits at the heart of a sprawling Lysterfield compound, which also features a tennis court, a putting green and elaborate gardens. The estate sold for an undisclosed price within its $3.7-$4.07m selling guide last year.",
   "imagename1": "64-1",
   "imagename2": "64-2",
   "imagename3": "64-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 65,
   "peopleid": 65,
   "title": "Frothing Sea",
   "address": "Gurney Cres, Seaforth, NSW",
   "desc": "Award-winning architect Robert Winter took inspiration from renowned US architect Frank Lloyd Wright's iconic landmark Fallingwater, a home he built over a waterfall in Pennsylvania in 1935, to design this three-level Seaforth trophy home called Pearl. The suspended infinity edge, saltwater, gas-heated pool has a luxury jacuzzi that sits alongside an integrated wet bar and second kitchen. The property is currently for sale through Chris Girling, of Ray White Lower North Shore, with a guide of $8m",
   "imagename1": "65-1",
   "imagename2": "65-2",
   "imagename3": "65-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 66,
   "peopleid": 66,
   "title": "Morning Glory",
   "address": "Vaucluse, NSW",
   "desc": "This pool on a clifftop at Vaucluse sits within an award winning garden designed by landscape architect Jane Irwin. While it is ideal for lap swimming, the pool is natural, with filtering achieved organically rather than through the use of chemicals. With water plants installed and thriving, it provides the perfect backdrop for the garden which leans into the drama of the natural environment around it. Pictures: Jane Irwin\n",
   "imagename1": "66-1",
   "imagename2": "66-2",
   "imagename3": "66-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 67,
   "peopleid": 67,
   "title": "Skybarn House",
   "address": "Walkerville, SA",
   "desc": "Designed by Max Pritchard Gunner Architects, Skybarn House is created in three pavilions and central to it all is an internal garden and long, elegant concrete lap pool, finished in textural large format aqua tiles. The long, narrow courtyard has ultimate privacy in its inner suburban setting, and the pool (by Elite Pools and Landscapes) and Japanese-style landscaped garden (by David Bapiste) can be seen from the elevated living pavilion, the long corridor, master bedroom and the guest pavilion at the far end. Surrounded by timber decking and screening, an overhead retractable pergola adds an industrial element and allows the pool to be used in any weather. This pool won the 2018 Winner Lap Pool – Concrete at the SPASA SA state awards.\nPicture: Sam Noonan\nelitepoolsandlandscapes.com.au\n",
   "imagename1": "67-1",
   "imagename2": "67-2",
   "imagename3": "67-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 68,
   "peopleid": 68,
   "title": "Balaam",
   "address": "Harbour Road, Hamilton, QLD",
   "desc": "Somewhat of a Brisbane icon, this no-expense-spared, highly engineered pool was especially designed by award-winning architect Shaun Lockyer to be striking, but also practical. The incredible cantilevered structure was set into the side of the first floor of the home so the original owner’s children could be seen from the kitchen when they were swimming. The suspended concrete pool has a glass front edge that one high-profile Brisbane real estate agent said was “rated so highly you could use it in Seaworld to keep polar bears in”. ‘Balaam’ has been described as one of Brisbane’s finest homes, sitting on an impressive 48.3m stretch of the Brisbane River.",
   "imagename1": "68-1",
   "imagename2": "68-2",
   "imagename3": "68-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 69,
   "peopleid": 69,
   "title": "Lake Energy",
   "address": "Lomond Circuit, Mawson Lakes, SA",
   "desc": "Pools are great, but let’s face it, the maintenance can be a little off-putting for some. That’s not the case with this stunning Mawson Lakes number, with its online listing describing it as a “fenced self-cleaning heated mineral pool with mood-lit LED waterfall feature, sun deck, and lakeside backdrop.” There’s not a single part of that that doesn’t sound idyllic. This pool really is for those that want to wow their guests while entertaining and it flows perfectly out from that stunning rear alfresco area. It’s the piece de resistance in an incredible home.",
   "imagename1": "69-1",
   "imagename2": "69-2",
   "imagename3": "69-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 70,
   "peopleid": 70,
   "title": "Peppermint Splash",
   "address": "Johnston Street, Peppermint Grove, WA",
   "desc": "As beautiful as this pool is – and trust us, it’s gorgeous – it’s on this list because of the house it’s attached to. See, pools in and of themselves are great, but where they really shine is when they are perfectly paired with a home and each complement the other. This contemporary design feels classically traditional when paired with the glamorous aesthetic of the mansion it’s attached to. Taking pride of place in the rear yard, it’s the perfect ending to a sumptuous tour through one of Western Australia’s most beautiful homes. Overlooked by a stunning pavilion, this amazing creation has all your luxe entertainment needs covered.",
   "imagename1": "70-1",
   "imagename2": "70-2",
   "imagename3": "70-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 71,
   "peopleid": 71,
   "title": "Harbour Room",
   "address": "Swains Crossing Road, Victor Harbor, SA",
   "desc": "It’s bigger than most of the rooms inside this palatial Victor Harbor mansion and has breathtaking panoramic bushland views – what’s not to love about this indoor pool? Inside a pavilion that is front and centre of the sprawling home, it is by far the property’s standout feature. The pool itself is 15m long and heated, while the pavilion surrounding it has soaring ceilings supported by ornate pillars, towering windows and feature staircases offering multiple access points around the house. There is also a spa to kick back and relax in and plenty of space surrounding the pool to entertain guests. It’s perfect year-round.",
   "imagename1": "71-1",
   "imagename2": "71-2",
   "imagename3": "71-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 72,
   "peopleid": 72,
   "title": "Front Row",
   "address": "Kurraba Point, NSW",
   "desc": "Proof that not all pools are created equal. And when you're a pool in an absolute harbourfront location with views of the Harbour Bridge, you shouldn't be judged harshly if you look down on other pools who don't have what you have. This is what you get when a pool becomes an accessory.",
   "imagename1": "72-1",
   "imagename2": "72-2",
   "imagename3": "72-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 73,
   "peopleid": 73,
   "title": "Silver Sovereign",
   "address": "Hampton Court, Sovereign Islands, QLD",
   "desc": "Award-winning architect Paul Clout designed this opulent home and integrated pool in the elite enclave of Sovereign Islands. Wrapping around the property's curved walls, so iconic of Clout's design's, the pool could be considered part water feature with its concrete stepping stones strategically dotted across the middle to allow passage from the terrace to the garden without getting wet. For those who do want to cool off you can splash around in the plunge pool/spa at the very end.",
   "imagename1": "73-1",
   "imagename2": "73-2",
   "imagename3": "73-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 74,
   "peopleid": 74,
   "title": "Walking on Water",
   "address": "Lorne, VIC",
   "desc": "Everything about this private Lorne compound screams resort living. The home — which was designed by Spaces Design Group and built by GD Constructions — set a Surf Coast record at $7.25m when it sold in January last year. And it’s easy to see how, with the two-storey house offering an incredible vista over Loutitt Bay and the rugged Great Ocean Road coastline. But also lower your eyes to the pool and the adjoining luxe pavilion boasting an outdoor kitchen, built-in seating, a gym, a shower and a changing room. Bi-fold glass doors open the pavilion to the pool, which is flanked by a deck and lawn hosting plenty of banana lounges.",
   "imagename1": "74-1",
   "imagename2": "74-2",
   "imagename3": "74-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 75,
   "peopleid": 75,
   "title": "Tropic Salute",
   "address": "Formosa Road, Gumdale, QLD",
   "desc": "There's a floating cabana above the freeform pool in this acreage property on the outskirts of Brisbane and while this is a great place to escape with your morning coffee or a good book, it's the swim-up bar with an entertainment unit behind that makes you feel you're in your own tropical island oasis. The owners did have this property on the market but have had a change of heart due to continued COVID border closures and have decided to stay.",
   "imagename1": "75-1",
   "imagename2": "75-2",
   "imagename3": "75-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 76,
   "peopleid": 76,
   "title": "The Good Life",
   "address": "College Park, SA",
   "desc": "This pool project, by Mermaid Pool Constructions, was a gold winner in the Renovation over $25,000 category. While its design is simple, the wide steps are highly practical and white tiles create luminosity in the water. It’s a striking combo with granite pavers edging the pool, decking and timber built-in seating and an alfresco pavilion and barbecue zone. A lush garden and lawn complement the pool that is fully fenced by glass partitions, so the family can have a clear, undisturbed view into the pool area.\n\nPicture Sarah Long, Longshot \nwww.mermaidpool.com.au\n",
   "imagename1": "76-1",
   "imagename2": "76-2",
   "imagename3": "76-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 77,
   "peopleid": 77,
   "title": "Party Out The Back",
   "address": "Cambridge Terrace, Malvern SA",
   "desc": "This stunning courtyard pool takes up the majority of the backyard, built up to the house with stepping stones and resort style decking as striking features. Adjacent, walls of glass allow for stunning views from the inside while the clear, pale blue tiles make the water look pristine. Designed and built by Elite Pools and Landscapes, this property and pool is so stunning it became the grand prize home of the Home Lottery and won awards at previous years’ SPASA awards.\nPicture: Longshot Constructions\nelitepoolsandlandscapes.com.au\n",
   "imagename1": "77-1",
   "imagename2": "77-2",
   "imagename3": "77-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 78,
   "peopleid": 78,
   "title": "Top of the mount",
   "address": "Mount Vernon, NSW",
   "desc": "Building designer Luke Van Jour from Distinct Innovations specialises in resort style homes in outer western Sydney where temperatures can peak in their 40s. This property at Mount Vernon is the perfect place to keep your cool with the pool at the centre of the outdoor space surrounded by frameless glass pool fencing. The fencing provides a barrier between pavilions on the sprawling site offering everything from a fire pit and pizza oven to lounge and bar areas. The perfect place to get on the beers.",
   "imagename1": "78-1",
   "imagename2": "78-2",
   "imagename3": "78-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 79,
   "peopleid": 79,
   "title": "King of the Valley",
   "address": "Kangaroo Valley, NSW",
   "desc": "Like swimming, living even, in your own pristine creek without all the fish and the weed and the mud and anything else that might upset you. If you're thinking of leaving the city behind and are worried that you can't take all the best bits with you, this pool is proof you can. The valley and forest views come as a bonus.",
   "imagename1": "79-1",
   "imagename2": "79-2",
   "imagename3": "79-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 80,
   "peopleid": 80,
   "title": "Little Grotto",
   "address": "Marscay Court, Burpengary QLD",
   "desc": "The owner of this house went shopping for a pool and came home with a water park. The custom-designed fitout includes two slides into the resort pool, and a waterfall that flows over a cave that is hiding a heated spa with a TV. Yabba dabba doo! \n",
   "imagename1": "80-1",
   "imagename2": "80-2",
   "imagename3": "80-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 81,
   "peopleid": 81,
   "title": "Urbane Tourmaline",
   "address": "Margaret St, Rozelle, NSW",
   "desc": "Inner city terrace homes are generally pressed for space, but this conundrum has led to a stylish rooftop pool. Squeezed in a little nook beside the house and next door, the mosaic pool blends seamlessly into the rooftop space. The pool has a glass wall, water feature and a ladder to climb in. Once you're finished, there are multiple entertaining and district views to enjoy.",
   "imagename1": "81-1",
   "imagename2": "81-2",
   "imagename3": "81-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 82,
   "peopleid": 82,
   "title": "River View",
   "address": "River Rd, Lower Portland, NSW",
   "desc": "Privacy and views make this property a must see for those looking to escape the city. The pool overlooks the Hawkesbury River right on the edge of a cliff. It is the perfect retreat in the middle of the bush, while the outlook provides the background for a sunset barbecue with friends.",
   "imagename1": "82-1",
   "imagename2": "82-2",
   "imagename3": "82-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 83,
   "peopleid": 83,
   "title": "Cloud Walk",
   "address": "Old Mt Cootha Road, Toowong, QLD",
   "desc": "Hidden within a tropical tiered garden is this gorgeous freeform pool that has received national attention for its design excellence. Curving around the front of the four-storey home at the foothills of Brisbane's Mount Coot-tha, the solar-heated, tiled infinity pool has stepping stones between the spa and the azure blue pool. This property is for sale with Expressions of Interest closing on March 10. \n",
   "imagename1": "83-1",
   "imagename2": "83-2",
   "imagename3": "83-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 84,
   "peopleid": 84,
   "title": "Suspended Swim",
   "address": "Echuca, VIC",
   "desc": "Swim among the treetops at this impressive floating pool in the yard of a tranquil Echuca home. The cleverly designed, blue-tiled swimming spot — built by KGB Constructions — has been built off the side of the property and suspended above the ground. It’s big enough to do laps and once they’re done, lounge on the water’s edge. The suspended concrete structure is connected to a covered balcony that’s primed for entertaining and taking in bushland views. And swimmers who are peckish after their dip can visit “Franko’s Bar and Grill” — an old railway storage container that has been transformed into a private bar and grill at the rear of the home",
   "imagename1": "84-1",
   "imagename2": "84-2",
   "imagename3": "84-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 85,
   "peopleid": 85,
   "title": "24/7 - 365",
   "address": "Greenhill Road, Burnside, SA",
   "desc": "The indoor pool that comes with this Burnside home is part of a fun-filled recreation package entertainers will love. The lower level of the three-storey, six-bedroom house is a dedicated recreation area – so it’s not just the pool that offers a swimmingly good time. The majority of the space is dedicated to the 9m gas heated pool, but there is also a gym, games room, bar and a separate bathroom so you don’t traipse water through the rest of the house. It’s perfect for pool parties with your friends and family, in either summer or winter. Or you could simply lounge by the pool and soak up the breathtaking views of Adelaide through the wide windows.",
   "imagename1": "85-1",
   "imagename2": "85-2",
   "imagename3": "85-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 86,
   "peopleid": 86,
   "title": "Eagle's Nest",
   "address": "Edgecliffe Boulevard, Collaroy, NSW",
   "desc": "A pool for all occasions and all moods. Who can't imagine themselves enjoying an early summers evening's beverage here overlooking God's Country before slipping into this H2O delight, without having to compromise on the view. Like all of the great Cool Pools, this one is the jewel in the crown of this palatial home.",
   "imagename1": "86-1",
   "imagename2": "86-2",
   "imagename3": "86-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 87,
   "peopleid": 87,
   "title": "Storage Dip",
   "address": "Clovelly, NSW",
   "desc": "Warehouses have become sought after inner city residences in recent years but they can limit your options for a quick dip. Technically an indoor pool, this waterhole was updated by Secret Gardens to provide a much needed, if small, place to cool off within this industrial style home known as The Stables. Skylights above the pool ensure it retains the feel of an outdoor pool.",
   "imagename1": "87-1",
   "imagename2": "87-2",
   "imagename3": "87-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 88,
   "peopleid": 88,
   "title": "Side Hustle",
   "address": "Powell Street, Joondanna, WA",
   "desc": "When a tech enthusiast, an architect and a boutique builder join forces to create the ultimate entertainers home, you get a pretty special end result. Built by multiple HIA award winner Ultimo Construction, the pool of this beautiful home is truly a highlight. Indeed it’s a central feature of the home, with the floorplan built around this glistening heated, salt water pool to effortlessly blend the inside with the outside to create a resort-style experience. With its built-in seating, feature wall, mood lighting and nearby green wall, it provides enough of a resort-style feel to distract you from the depressing fact that none of us can travel abroad.",
   "imagename1": "88-1",
   "imagename2": "88-2",
   "imagename3": "88-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 89,
   "peopleid": 89,
   "title": "My Darling",
   "address": "Lindsay Avenue, Darling Point, NSW",
   "desc": "He was the overall winner in 2019 but there was no Sydney to Hobart for Matt Allen, skipper and owner of Ichi Ban, in 2020. But at least he and his wife, Lisa, were able to enjoy the holiday period in the magnificent harbourside infinity pool with heated spa. The huge Darling Point waterfront estate could be all yours for a mere $70m.",
   "imagename1": "89-1",
   "imagename2": "89-2",
   "imagename3": "89-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 90,
   "peopleid": 90,
   "title": "Swimming with the Stars",
   "address": "Brisbane Corso, Yeronga, QLD",
   "desc": "This pool perched over the Brisbane River in Yeronga comes with some serious sporting kudos. The property to which it belongs was until recently the family home of eight-time Olympic medallist Susie O'Neill, aka Madame Butterfly. The heated Elite Fastlane pool is one of only two in Australia and allows you to train like an elite athlete. It works by creating a current, which you swim against. Ms O'Neill said it was a perfect way to exercise at home if you couldn't get to a 50m pool.",
   "imagename1": "90-1",
   "imagename2": "90-2",
   "imagename3": "90-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 91,
   "peopleid": 91,
   "title": "Sunny Daze",
   "address": "Webb Road, Sunshine Beach, QLD",
   "desc": "You know you've made it when your beachfront pool is a stunning glass-fronted stunner designed to give you uninterrupted ocean views while you do laps. Reminiscent of the luxurious glass pool experience at A-list Fiji resort Laucala Island - frequented by the likes of Oprah Winfrey - this property was last sold by Melbourne IT entrepreneur Danny Wallis for $22m in 2018. It sits on almost an acre of prime beachfront land and is next to a nature reserve.",
   "imagename1": "91-1",
   "imagename2": "91-2",
   "imagename3": "91-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 92,
   "peopleid": 92,
   "title": "Byron's Best",
   "address": "Marine Parade, Byron Bay, NSW",
   "desc": "Byron Bay isn't about tramping around barefoot in the camping ground any more. No, now it's all about the Hollywood celebrities, and the big money houses. Such as this record $22m baby that was snapped up very recently. And if you're going to blow that sort of money on a home it needs to have a pool overlooking The Pass. Exactly. Like. This.",
   "imagename1": "92-1",
   "imagename2": "92-2",
   "imagename3": "92-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 93,
   "peopleid": 93,
   "title": "Hills Bells",
   "address": "March Street, Bellevue Hill , NSW",
   "desc": "The sun-drenched rooftop pool of this penthouse sold by Real Housewives of Sydney star Matty Samaei last March was one of the reasons a Hunters Hill Chinese-Australian family fell in love it. The family bought the penthouse and the garden apartment in the duplex for just under $9m as COVID-19 hit. \"We're so lucky,\" Samaei said after the shock deal. The two luxury residences were designed by DKO Architecture. Magical by day and night, the views sweep across Rose Bay to Manly in the north, Harbour Bridge and city skyline in the west and ocean in the east.",
   "imagename1": "93-1",
   "imagename2": "93-2",
   "imagename3": "93-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 94,
   "peopleid": 94,
   "title": "Penthouse Wonder",
   "address": "South Melbourne, VIC",
   "desc": "Swimmers can soak in 360-degree views of the Melbourne city skyline and Port Phillip Bay from this penthouse’s divine rooftop pool. The custom-designed feature isn’t quite long enough for lap swimming, stretching 8.5m. But it’s flanked by an alfresco terrace featuring a barbecue, making it the ideal spot for a summer soiree. It forms part of a sprawling 545 sqm m penthouse that was created by big-name developer Tim Gurner and renowned interior designer David Hicks to feature more than $100,000 worth of Italian marble and $20,000 of custom light fittings. The luxe apartment sold for an undisclosed price in December, after being listed for $5.5-$6m.",
   "imagename1": "94-1",
   "imagename2": "94-2",
   "imagename3": "94-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 95,
   "peopleid": 95,
   "title": "Endless Sea",
   "address": "Curlewis, VIC",
   "desc": "It’s hard to tell where this Bellarine Peninsula pad’s infinity pool ends and the ocean begins.\nThe feature juts out from the architecturally designed home’s north west-facing deck to offer uninterrupted 180-degree views of Corio Bay, the You Yangs, and the Geelong and Melbourne city skylines. The property, created by Hamilton Marino Builders, held the City of Greater Geelong’s record price after former Hugo Boss managing director Aaron Kanat sold it for $5.6m in 2017. Its 2ha landholding also boasted a tennis court and lush coastal gardens.",
   "imagename1": "95-1",
   "imagename2": "95-2",
   "imagename3": "95-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 96,
   "peopleid": 96,
   "title": "Urban Hideaway",
   "address": "Willoughby, NSW",
   "desc": "Hidden deep, deep, deep within suburban Sydney, this is the sort of pool Indiana Jones would be tasked with finding. You can imagine all the bad guys he would have to fight off along the way: uber cool hipsters, avaricious Instagrammers, double parking Audi owners, and traffic thicker and scarier than an Amazon backwater full of anacondas. But when Indy gets there, the destination will be worth the journey.",
   "imagename1": "96-1",
   "imagename2": "96-2",
   "imagename3": "96-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 97,
   "peopleid": 97,
   "title": "Deepwater Horizon",
   "address": "Saunders Street, Mosman Park, WA",
   "desc": "Imagine kicking back with a G&T as you soak in those sumptuous views. And those curved steps down into it make it feel less like something added on later in the building design, but rather something that was always intended to be a true focal point of the home that was always meant to be the shining star. If you were ever looking for a place to laze around, soak up the sun and watch the world go by, you’d be hard pressed to beat this one.",
   "imagename1": "97-1",
   "imagename2": "97-2",
   "imagename3": "97-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 98,
   "peopleid": 98,
   "title": "Twin Palms",
   "address": "Duncraig Road, Applecross, WA",
   "desc": "When it comes to stunning Western Australian pools, they don’t come much more impressive than this. And this pool’s charm really does lie in those views. It might not be everyone’s cup of tea to have the pool and spa separated by a pathway, but we think it works nicely, separating them as two distinctly separate indulgent spaces. As beautiful as they are, the real drawcard here’s that view. It’s set on a stunning entertainer’s terrace with separate and offers unobstructed 180-degree views over Perth’s gorgeous city and the beautiful Swan River. We could think of worse places to enjoy a Margaret River Cabernet Sauvignon.",
   "imagename1": "98-1",
   "imagename2": "98-2",
   "imagename3": "98-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 99,
   "peopleid": 99,
   "title": "Pittwater Rules",
   "address": "Pittwater Road, Bayview, NSW",
   "desc": "The history of pools - and the world - can be divided into pre-infinity and post-infinity. And these days it's hard to imagine what life was like before infinity pools existed. They are up there with the beach umbrella, zinc cream and the game of cricket as humankind's greatest summer inventions. This pool is proof positive of that. To infinity and beyond pool lovers!",
   "imagename1": "99-1",
   "imagename2": "99-2",
   "imagename3": "99-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 100,
   "peopleid": 100,
   "title": "Capital Gains",
   "address": "Gunn Street, Yarralumla, ACT",
   "desc": "This home is proof of how far the humble Aussie suburban pool has come since the days of sky blue marblesheen and light brown pebblecrete. A stone's throw from the PM's Canberra home The Lodge, the pool and its incredible outdoor area are the heart of this home, not the kitchen. With an uber trendy underground window into the water from the garage, the pool has inspired much of the architectural brilliance of the house. Unfortunately for ScoMo, it's not for sale.",
   "imagename1": "100-1",
   "imagename2": "100-2",
   "imagename3": "100-3",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 }
]

export default Data


// WEBPACK FOOTER //
// ./src/components/Data.js